import { Injectable, inject } from '@angular/core';
import { ProfileService } from '../app/profile.service';
import { IMenu } from '../../types/menu.type';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private profileService = inject(ProfileService);

  filterMenu(menu: IMenu[]): IMenu[] {
    return menu
      .map((item) => ({
        ...item,
        submenu: item.submenu ? this.filterMenu(item.submenu) : undefined,
      }))
      .filter((item) => this.isVisible(item));
  }

  private isVisible(item: IMenu): boolean {
    if (item.roles?.length && item.roles.some((role) => this.profileService.hasRole(role))) {
      return true;
    }
    if (item.permits?.length && this.profileService.hasAnyPermit(item.permits)) {
      return true;
    }

    if (!item.roles && !item.permits) {
      return true;
    }
    return false;
  }
}
